import type {FunctionComponent} from "react";
import {Typography} from "@mui/material";
import {WarningOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";

export interface IWarningToastContent {
    message: string,
}

const WarningToastContent: FunctionComponent<ToastContentProps<IWarningToastContent>> =
    ({
         data,
     }) => {

        return (
            <>
                <div className={'toast-content'}>
                    <WarningOutlined color={'warning'} sx={{marginRight: 1}}/>
                    <Typography variant={'body2'}>
                        {data?.message ?? ''}
                    </Typography>
                </div>
            </>
        )
    }

export default WarningToastContent;
